export default "__VITE_ASSET__B8n23Yly__"